import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9f8ce0e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "flex flex-col gap-y-8 mx-auto border-x border-slate-50 border-indigo-500",
    style: { "width": "100%", "padding-left": "15px", "background": "#f9fafb", "height": "100%" }
};
const _hoisted_2 = { class: "items-center" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, " Yield Rules ", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-plus-circle",
    style: { "font-size": "1.5rem" }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-weight": "700" } }, " Add Yield Rule ", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-pen-to-square",
    style: { "font-size": "1.5rem" }
}, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-trash",
    style: { "font-size": "1.5rem" }
}, null, -1));
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';
import Modal from '@apparatix/Components/Modal.vue';
import PricingRule from '@apparatix/Components/PricingRule.vue';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
const TOAST_LIFE = 3000;
export default /*#__PURE__*/ _defineComponent({
    __name: 'YieldRuleOverview',
    props: {
        yieldRules: {}
    },
    setup(__props) {
        const props = __props;
        const yieldRuleArray = ref(JSON.parse(props.yieldRules));
        const confirm = useConfirm();
        const toast = useToast();
        const modalVisible = ref(false);
        const action = ref(null);
        const isLoading = ref(false);
        const selectedRow = ref({ name: '', id: undefined, rowId: undefined });
        const dataPoints = ref();
        const pricingRule = ref();
        const dropdownLists = ref();
        const modalHeaderText = computed(() => {
            if (!action.value)
                return null;
            return action.value === 'create' ? 'Create Yield Rule' : 'Edit Yield Rule';
        });
        const onCreateClick = async () => {
            modalVisible.value = false;
            isLoading.value = true;
            action.value = 'create';
            selectedRow.value = { id: null, name: '', rowId: 0 };
            const data = await axios.get(`/pricingRules/create?returnJson=true`);
            if (data.status !== 200) {
                const message = data.data?.message ?? 'Something went wrong';
                toast.add({ severity: 'error', summary: 'Error', detail: message, life: TOAST_LIFE });
            }
            dataPoints.value = data.data.dataPoints;
            pricingRule.value = data.data.pricingRule;
            dropdownLists.value = data.data.dropdownLists;
            modalVisible.value = true;
            isLoading.value = false;
        };
        const onEditClick = async (rateCode) => {
            modalVisible.value = false;
            isLoading.value = true;
            action.value = 'edit';
            selectedRow.value = { id: rateCode.id, name: rateCode.name, rowId: 0 };
            const data = await axios.get(`/pricingRules/${selectedRow.value.id}?returnJson=true`);
            if (data.status !== 200) {
                const message = data.data?.message ?? 'Something went wrong';
                toast.add({ severity: 'error', summary: 'Error', detail: message, life: TOAST_LIFE });
            }
            dataPoints.value = data.data.dataPoints;
            pricingRule.value = data.data.pricingRule;
            dropdownLists.value = data.data.dropdownLists;
            modalVisible.value = true;
            isLoading.value = false;
        };
        const onDeleteClick = async (rateCode) => {
            selectedRow.value = { id: rateCode.id, name: rateCode.name, rowId: 0 };
            confirm.require({
                message: 'Are you sure you want to delete this yield rule?',
                header: 'Confirm delete',
                rejectLabel: 'Cancel',
                acceptLabel: 'Delete',
                accept: () => deleteRule(),
            });
        };
        const deleteRule = async () => {
            try {
                const result = await axios.delete(`/pricingRules/${selectedRow.value.id}`);
                if (result.status === 200) {
                    yieldRuleArray.value = yieldRuleArray.value.filter(code => code.id !== selectedRow.value.id);
                    toast.add({ severity: 'success', summary: 'Success', detail: 'Rule successfully deleted', life: TOAST_LIFE });
                }
                else {
                    toast.add({ severity: 'error', summary: 'Error', detail: 'Error deleting rule', life: TOAST_LIFE });
                }
            }
            catch (error) {
                console.log('caught error', error);
                if (error.response?.data?.message === 'THIS RULE IS CURRENTLY IN USE') {
                    toast.add({
                        severity: 'error',
                        summary: 'Yield Rule in use',
                        detail: 'This yield rule is currently assigned to a code, and cannot be deleted. If you want to delete this rule, first unassign this rule from any codes',
                    });
                }
                else {
                    toast.add({ severity: 'error', summary: 'Error', detail: 'Error deleting rule', life: TOAST_LIFE });
                }
            }
        };
        const onRuleCreated = (pricingRule) => {
            console.log(pricingRule);
            let isActive = pricingRule?.is_active ? 'Yes' : 'No';
            let shouldStopRules = pricingRule?.should_stop_rules ? 'Yes' : 'No';
            let startDate = pricingRule.starts_at != 'Invalid Date' ? pricingRule.starts_at.toISOString().split('T')[0] : '';
            let endDate = pricingRule.ends_at != 'Invalid Date' ? pricingRule.ends_at.toISOString().split('T')[0] : '';
            yieldRuleArray.value.push({ id: pricingRule.id, name: pricingRule.name, description: pricingRule?.description, is_active: isActive, should_stop_rules: shouldStopRules, starts_at: startDate, ends_at: endDate });
        };
        const onRuleUpdated = (pricingRule) => {
            let changedCodeIndex = yieldRuleArray.value.findIndex(code => code.id === pricingRule.id);
            yieldRuleArray.value[changedCodeIndex].name = pricingRule.name;
            yieldRuleArray.value[changedCodeIndex].description = pricingRule?.description;
            yieldRuleArray.value[changedCodeIndex].is_active = pricingRule?.is_active ? 'Yes' : 'No';
            yieldRuleArray.value[changedCodeIndex].should_stop_rules = pricingRule?.should_stop_rules ? 'Yes' : 'No';
            yieldRuleArray.value[changedCodeIndex].starts_at = (pricingRule.starts_at != 'Invalid Date' && pricingRule.starts_at) ? pricingRule.starts_at.toISOString().split('T')[0] : '';
            yieldRuleArray.value[changedCodeIndex].ends_at = (pricingRule.ends_at != 'Invalid Date' && pricingRule.ends_at) ? pricingRule.ends_at.toISOString().split('T')[0] : '';
        };
        const onClose = () => cleanup();
        const cleanup = () => {
            modalVisible.value = false;
            isLoading.value = false;
            action.value = undefined;
        };
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    _createVNode(_unref(DataTable), {
                        "striped-rows": "",
                        value: yieldRuleArray.value,
                        class: "p-datatable-sm"
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _hoisted_3,
                                _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                    size: "small",
                                    rounded: "",
                                    outlined: "",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (onCreateClick())),
                                    style: { "background": "#2B9C74", "color": "white" }
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_4,
                                        _createTextVNode(),
                                        _hoisted_5
                                    ]),
                                    _: 1
                                })), [
                                    [
                                        _directive_tooltip,
                                        'Create a New Yield Rule',
                                        void 0,
                                        { left: true }
                                    ]
                                ])
                            ])
                        ]),
                        empty: _withCtx(() => [
                            _createTextVNode(" No Rules found. ")
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                                field: "name",
                                header: "Name"
                            }),
                            _createVNode(_unref(Column), {
                                field: "description",
                                header: "Description"
                            }),
                            _createVNode(_unref(Column), {
                                field: "starts_at",
                                header: "Start Date",
                                style: { "width": "120px" }
                            }),
                            _createVNode(_unref(Column), {
                                field: "ends_at",
                                header: "End Date",
                                style: { "width": "120px" }
                            }),
                            _createVNode(_unref(Column), {
                                field: "is_active",
                                header: "Active",
                                style: { "width": "100px" }
                            }),
                            _createVNode(_unref(Column), {
                                field: "should_stop_rules",
                                header: "Stop Rules",
                                style: { "width": "100px" }
                            }),
                            _createVNode(_unref(Column), { style: { "width": "20px" } }, {
                                body: _withCtx((slotProps) => [
                                    _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        class: "icon-button",
                                        style: { "color": "#2FA3EE" },
                                        onClick: ($event) => (onEditClick(slotProps.data))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_6
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"])), [
                                        [
                                            _directive_tooltip,
                                            'Edit Rule',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), { style: { "width": "20px" } }, {
                                body: _withCtx((slotProps) => [
                                    _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                        size: "small",
                                        severity: "danger",
                                        rounded: "",
                                        outlined: "",
                                        class: "icon-button",
                                        style: { "color": "#E11D48" },
                                        onClick: ($event) => (onDeleteClick(slotProps.data))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_7
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"])), [
                                        [
                                            _directive_tooltip,
                                            'Delete Code',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["value"])
                ]),
                _createVNode(Modal, {
                    position: "top",
                    visible: modalVisible.value,
                    title: modalHeaderText.value,
                    subtitle: selectedRow.value.name,
                    icon: "circlePlus",
                    "on-close": onClose,
                    padding: "0"
                }, {
                    body: _withCtx(() => [
                        (isLoading.value)
                            ? (_openBlock(), _createBlock(FormSkeleton, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createVNode(PricingRule, {
                            "dropdown-lists": dropdownLists.value,
                            "onUpdate:dropdownLists": _cache[1] || (_cache[1] = ($event) => ((dropdownLists).value = $event)),
                            "data-points": dataPoints.value,
                            "onUpdate:dataPoints": _cache[2] || (_cache[2] = ($event) => ((dataPoints).value = $event)),
                            "pricing-rule": pricingRule.value,
                            "onUpdate:pricingRule": _cache[3] || (_cache[3] = ($event) => ((pricingRule).value = $event)),
                            onCreatedNewRule: onRuleCreated,
                            onUpdatedExistingRule: onRuleUpdated,
                            onCleanup: cleanup
                        }, null, 8, ["dropdown-lists", "data-points", "pricing-rule"])
                    ]),
                    _: 1
                }, 8, ["visible", "title", "subtitle"]),
                _createVNode(_unref(ConfirmDialog)),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
